class NewsFeedService {
    constructor() {
        this.state = {
            tags: [],
            listeners: [],
        };
    }

    add(tag) {
        if (!this.state.tags.includes(tag)) {
            this.state.tags.push(tag);
        }

        this._onChange();
    }

    remove(tag) {
        this.state.tags = this.state.tags.filter((stateTag) =>
            stateTag !== tag);

        this._onChange();
    }

    onChange = (callback) => {
        if (!callback || typeof callback !== 'function') {
            throw new Error('You have to provide function as callback');
        }

        this.state.listeners.push(callback);
    }

    _onChange() {
        this.state.listeners.forEach((callback) => callback(this.state.tags));
    }
}

export default new NewsFeedService();
